var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.endOfServiceDate)?_c('ParagraphBody',{class:[
    _vm.$style.label,
    _vm.getServicTagStyle
  ],attrs:{"weight":_vm.paragraphWeight}},[_vm._v(" "+_vm._s(_vm.endOfServiceDate)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }